module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"QuoteBlock":{"quoteImageAltText":"Uvozovky"}},"en":{}}')
  delete Component.options._Ctor
}
